import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { orderData } from "../../data/OrderData";
import { Domain } from "../../Domain/Domain";
import AdminPagination from "../AdminPagination/AdminPagination";
import { getCookie } from "../cookie/getCookie";
import SmallSpinner from "../Spinner/SmallSpinner";
import classes from "./TechnicalHubStyles.module.css";
import { BsSearch } from "react-icons/bs";


const ManageTechnicians = (): JSX.Element => {
  const [technicians, setTechnicians] = useState<any>([]);
  const [arrayIsEmpty, setArrayIsEmpty] = useState<boolean>(false);
  const naviagte = useNavigate();

  useEffect(() => {
    axios
      .get(Domain() + "/api/v1/admin/technicians", {
        headers: {
          Authorization: getCookie(),
          "Content-Type": "application/json; charset=utf-8",
        },
      })
      .then((response: any) => {
        console.log(response);
        if (response.data.status === 200) setTechnicians(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


      const [search, setSearch] = useState('')

      const setSearchParameter = (event:any) => {
          if(event.target.value !== null){
            setSearch(event.target.value)
          }
      }

      //search form
      const onSubmitHandler = (val :any) => {
        
        axios
        .get("https://apiv2.electronicshop.com.ng/search-technician?resquest_payload="+search, {
          headers: {
            Authorization: "Bearer " + getCookie(),
            "Content-Type": "application/json",
          },
        })
        .then((response: any) => {
          if (response.status === 200){
            setTechnicians([response.data])
          }
          // console.log([response.data]);
        })
        .catch((error) => {
          console.log(error);
        });
    };


  const onNavigateHandler = (data: any) => {
    naviagte("/admin-technical-details?id=" + data);
  };

  const [pageNumber, setPageNumber] = useState<number>(0);
  const onDecreaseHandler = () => {
    if (pageNumber > 0) setPageNumber((prevState) => prevState - 1);
  };
  const onIncreaseHandler = () => setPageNumber((prevState) => prevState + 1);
  useEffect(() => {
    const url = Domain() + `/api/v1/admin/technicians/more?page=${pageNumber}`;

    fetch(url, {
      headers: {
        Authorization: getCookie(),
        "Content-Type": "application/json; charset=utf-8",
      },
    })
      .then((res) => res.json())
      .then((response: any) => {
        setTechnicians(response.data);
        setTimeout(() => window.scrollTo(0, 0), 0);
        if (response.data?.length! < 1) {
          setArrayIsEmpty(true);
        } else {
          setArrayIsEmpty(false);
        }
      })
      .catch((error) => {});
  }, [pageNumber]);

  return (
    <>
      <div className={classes.search_order_input}>
          <input
            type="text"
            name="productName"
            onChange={setSearchParameter}
            placeholder="Search for a product"
          />
          <div
            className={classes.search_icon}
            onClick={onSubmitHandler}
            // ref={searchRef}
          >
            <i>
              <BsSearch />
            </i>
          </div>
        </div>



      <h1>{arrayIsEmpty === false ? "" : "No item found"}</h1>


      {technicians.length < 1 ? (
        <>
          {arrayIsEmpty === false && (
            <div style={{ margin: "10px 0px" }}>
              <SmallSpinner />
            </div>
          )}
        </>
      ) : (
        <div className={classes.order_table}>
          <table className={classes.table_section}>
            <tbody>
              <tr className={classes.header_section}>
                <td>#</td>
                <td>Technician</td>
                <td>Technician ID</td>
                <td>Email</td>
                <td>Specification</td>
                <td>Status</td>
                <td>Verification</td>
                <td>Joined</td>
              </tr>
              {technicians.map((cur: any, index: number) => (
                <tr
                  key={cur.id}
                  className={classes.lists_}
                  onClick={() => onNavigateHandler(cur.id)}
                >
                  <td>{index + 1}</td>
                  <td>
                    {cur.firstName} {cur.surname}
                  </td>
                  <td>{cur.technicianId}</td>
                  <td>{cur.email}</td>
                  <td>{JSON.parse(cur.specification).toString()}</td>
                  <td>{cur?.is_active! ? "Active" : "Inactive"}</td>
                  <td>{cur?.is_verified! ? "Verified" : "Unverified"}</td>
                  <td>{new Date(cur?.createdAt!).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <AdminPagination
        onDecreaseHandler={onDecreaseHandler}
        onIncreaseHandler={onIncreaseHandler}
        pageNumber={pageNumber + 1}
      />
    </>
  );
};

export default ManageTechnicians;
